export default __webpack_public_path__ + "static/media/180.3cd28f11.png";